<template>
  <div>
    <ReportMobileFrame
      v-if="$vuetify.breakpoint.smAndDown"
      :loading="isLoading"
      :empty="!isLoading && data.length === 0"
      empty-text="No refunds found for the selected range."
    >
      <template #filters>
        <div class="report-dates-grid">
          <MobileDateField label="Start Date" :value="dates[0]" @input="onMobileDateChange(0, $event)" />
          <MobileDateField label="End Date" align="right" :value="dates[1] || dates[0]" @input="onMobileDateChange(1, $event)" />
        </div>
        <v-select
          v-if="stores.length > 1"
          :items="stores" item-text="name" item-value="id"
          v-model="selectedStoreId"
          label="Store" outlined dense hide-details class="mt-2"
          @change="load"
        />
      </template>

      <div v-for="group in groupedByDate" :key="group.dateKey">
        <ReportGroupHeader :label="group.dateLabel" />
        <ReportListRow v-for="(item, idx) in group.items" :key="group.dateKey + '-' + idx">
          <template #leading>
            <div class="report-payment-badge report-payment-badge--card">
              <v-icon dark size="18">mdi-cash-refund</v-icon>
            </div>
          </template>
          <template #title>£{{ Number(item.refundedAmount || 0).toFixed(2) }}</template>
          <template #subtitle>
            {{ item.staff || '—' }}{{ item.refundedReason ? ' · ' + item.refundedReason : '' }}
          </template>
          <template #trailing>
            <span class="report-time">{{ moment(item.refundedAt).format('HH:mm') }}</span>
          </template>
        </ReportListRow>
      </div>
    </ReportMobileFrame>

    <template v-else>
    <v-toolbar flat class="toolbar-container mb-2" height='100'>
      <v-row>
        <v-col>
          <div class="toolbar-datepicker">
            <DateRangePicker :initialDates="dates" @blur="updateDates"  />
          </div>
        </v-col>

        <v-col v-if="stores.length > 1">
          <v-select :items="stores" item-text="name" v-model="selectedStoreId" item-value="id" />
        </v-col>
      </v-row>
    </v-toolbar>
    <v-row>
      <v-col>
        <v-btn block class="search-btn" type="button" color="success" v-on:click="load">
          SEARCH
        </v-btn>
      </v-col>
    </v-row>
    <!-- <v-row justify="center">
       <v-toolbar flat class="toolbar-container" height='100'>
          <div class="toolbar-content">
            <div class="toolbar-datepicker">
              <DateRangePicker :initialDates="dates" @blur="updateDates"  />
            </div>

            <v-select :items="stores" item-text="name" v-model="selectedStoreId" item-value="id" />

            <v-spacer></v-spacer>

            <v-btn class="search-btn" type="button" color="success" v-on:click="load">
              SEARCH
            </v-btn>
          </div>
       </v-toolbar>
    </v-row> -->

     <v-row>
       <v-data-table 
        :headers="headers" :items="data" 
        :loading="isLoading" :items-per-page="-1"
        item-key="refundedAt" class="elevation-1 mt-5 flex-grow-1">

        <template v-slot:[`item.refundedAt`]="{ item }">
          {{ moment(item.refundedAt).format("DD/MM/yyyy HH:mm:ss") }}
        </template>
        
      </v-data-table>
    </v-row>
    </template>
  </div>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker.vue';
import ReportMobileFrame from '@/components/reports/ReportMobileFrame.vue';
import ReportGroupHeader from '@/components/reports/ReportGroupHeader.vue';
import ReportListRow from '@/components/reports/ReportListRow.vue';
import MobileDateField from '@/components/reports/MobileDateField.vue';
import moment from 'moment';
import { reportService } from '@/services';
import { userService } from '@/services';
import router from "../../router";

export default {

  name: 'Refunds',
  components: {
    DateRangePicker,
    ReportMobileFrame,
    ReportGroupHeader,
    ReportListRow,
    MobileDateField
  },
  data: vm => ({
    dates: [new Date().toISOString().substr(0, 10)],

    stores: [],
    selectedStoreId: null,

    isLoading: false,
    data: [],
    headers: [
      { text: 'Refunded At', align: 'start', sortable: true, filterable: true, value: 'refundedAt' },
      { text: 'Amount', align: 'start', sortable: true, filterable: true, value: 'refundedAmount' },
      { text: 'Reason', align: 'start', sortable: true, filterable: true, value: 'refundedReason' },
      { text: 'Staff', align: 'start', sortable: true, filterable: true, value: 'staff' },
    ],
  }),
  async created () {
    if (userService.isStaff()) {
      router.push('/products');
    }
    
    this.stores = await reportService.getStores();
    this.stores.unshift({
      id: null,
      name: 'All'
    });


    this.load();
  },
 methods: {
    updateDates(newDates) {
      this.dates = newDates;
    },
    async load() {
      var startDate = this.dates[0];
      var endDate = this.dates[0];
      if (this.dates.length > 1)
        endDate = this.dates[1];

      this.isLoading = true;
      this.data = await reportService.getRefundReport(startDate, endDate, this.selectedStoreId);
      this.isLoading = false;
    },
    onMobileDateChange(index, value) {
      if (!value) return;
      const next = this.dates.slice();
      while (next.length <= index) next.push(value);
      next[index] = value;
      if (index === 0) next[1] = value;
      this.dates = next;
      this.load();
    }
  },
  computed: {
    groupedByDate() {
      const sorted = this.data.slice().sort((a, b) => new Date(b.refundedAt) - new Date(a.refundedAt));
      const groups = new Map();
      for (const item of sorted) {
        const m = this.moment(item.refundedAt);
        const key = m.format('YYYY-MM-DD');
        if (!groups.has(key)) groups.set(key, { dateKey: key, dateLabel: m.format('DD MMM YYYY'), items: [] });
        groups.get(key).items.push(item);
      }
      return Array.from(groups.values());
    }
  }
}
</script>

<style lang="scss" scoped>
  .toolbar-container {
    background: #FFF !important;
    padding: 10px;
    height: auto;
    border-radius: 8px;

    border: 1px solid lighten(#7B5CD8, 30);
  }

  .toolbar-content {
    display: flex;
    flex-direction: row;
    width: 100%;

    .toolbar-datepicker {
      width: 250px;
    }
  }

</style>
